import MixinVue from '../mixins/WexVue';

// Filters
MixinVue.methods.vue.filters = {
    ...MixinVue.methods.vue.filters,
    ...{
        testFilter() {
            return 'This is a test filter !!';
        },
    },
};

// Methods
MixinVue.methods.vue.methods = {
    ...MixinVue.methods.vue.methods,
    ...{
        formatShortDate: function (date, timezone, isOnline) {
            return this.getLocalizedMoment(date, timezone, isOnline).format(
                'L'
            );
        },

        dateFullText: function (date, timezone, isOnline) {
            return this.getLocalizedMoment(date, timezone, isOnline).format(
                'dddd D MMM YYYY'
            );
        },

        getLocalizedMoment(date, timezone, isOnline) {
            let momentDate = app.lib.moment.tz(
                date.substring(0, 10) + ' ' + date.substring(11, 19),
                timezone
            );

            if (isOnline) {
                momentDate = momentDate.tz(app.locale.getUserTimezone());
            }

            return momentDate;
        },

        dateDayFullText: function (date, timezone, isOnline) {
            return this.getLocalizedMoment(date, timezone, isOnline).format(
                'dddd'
            );
        },

        dateDayNumber: function (date, timezone, isOnline) {
            return this.getLocalizedMoment(date, timezone, isOnline).format(
                'D'
            );
        },

        dateMonthAndYear: function (date, timezone, isOnline) {
            return this.getLocalizedMoment(date, timezone, isOnline).format(
                'MMM YYYY'
            );
        },

        hour: function (date, timezone, isOnline) {
            return this.getLocalizedMoment(date, timezone, isOnline).format(
                'LT'
            );
        },

        hours: function (dateStart, dateEnd, timezone, isOnline) {
            let hourStart = this.hour(dateStart, timezone, isOnline);
            let hourEnd = this.hour(dateEnd, timezone, isOnline);

            return hourStart + '&nbsp;-&nbsp;' + hourEnd;
        },

        convertTimezoneToUtcOffset: function (timezone) {
            return Math.round(app.lib.moment().tz(timezone).utcOffset() / 60);
        },
    },
};

export default MixinVue;
